import { render, staticRenderFns } from "./TownList.vue?vue&type=template&id=362200a7&scoped=true&"
import script from "./TownList.vue?vue&type=script&lang=js&"
export * from "./TownList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "362200a7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/bamboo-agent-home/xml-data/build-dir/WWW-WWW-JOB1/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('362200a7')) {
      api.createRecord('362200a7', component.options)
    } else {
      api.reload('362200a7', component.options)
    }
    module.hot.accept("./TownList.vue?vue&type=template&id=362200a7&scoped=true&", function () {
      api.rerender('362200a7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/src/components/outagecenter/TownList.vue"
export default component.exports